// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_paginationContainer__VqRN1 {
  display: flex;
  list-style-type: none;
  padding: 0;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 2rem;
}

.Pagination_paginationItem__6q3z4 {
  padding: 0.5rem 1rem;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid transparent;
  cursor: pointer;
  font-size: 1rem;
  color: #495867;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.12s ease;
}
.Pagination_paginationItem__6q3z4 svg {
  font-size: 1rem;
}
.Pagination_paginationItem__6q3z4.Pagination_dots__6NsaB {
  cursor: default;
}
.Pagination_paginationItem__6q3z4:not(.Pagination_disabled__owdrN):not(.Pagination_selected__MZoCF):not(.Pagination_dots__6NsaB):hover {
  border-color: rgba(130, 177, 148, 0.88);
  background-color: rgba(130, 177, 148, 0.12);
  color: #32453B;
}
.Pagination_paginationItem__6q3z4:not(.Pagination_disabled__owdrN):not(.Pagination_selected__MZoCF):not(.Pagination_dots__6NsaB):active {
  border-color: #82B194;
  background-color: rgba(130, 177, 148, 0.18);
  transform: translateY(1px);
}

.Pagination_selected__MZoCF {
  background: #7A9E7E;
  color: white;
  font-weight: bold;
}

.Pagination_disabled__owdrN {
  pointer-events: none;
  color: #cccccc;
}
.Pagination_disabled__owdrN:hover {
  background-color: transparent;
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Pagination/Pagination.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EAEA,wGAAA;AAAJ;AAEI;EACE,eAAA;AAAN;AAGI;EACI,eAAA;AADR;AAII;EACI,uCAAA;EACA,2CAAA;EACA,cAAA;AAFR;AAKI;EACI,qBAAA;EACA,2CAAA;EACA,0BAAA;AAHR;;AAOA;EACI,mBAAA;EACA,YAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,oBAAA;EACA,cAAA;AAJJ;AAMI;EACI,6BAAA;EACA,eAAA;AAJR","sourcesContent":[".paginationContainer {\n    display: flex;\n    list-style-type: none;\n    padding: 0;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 2rem;\n}\n\n.paginationItem {\n    padding: 0.5rem 1rem;\n    height: 40px;\n    width: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    border-radius: 50%;\n    border: 1px solid transparent;\n    cursor: pointer;\n    font-size: 1rem;\n    color: #495867;\n    \n    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.12s ease;\n    \n    svg {\n      font-size: 1rem;\n    }\n\n    &.dots {\n        cursor: default;\n    }\n\n    &:not(.disabled):not(.selected):not(.dots):hover {\n        border-color: rgba(130, 177, 148, 0.88);\n        background-color: rgba(130, 177, 148, 0.12);\n        color: #32453B;\n    }\n\n    &:not(.disabled):not(.selected):not(.dots):active {\n        border-color: #82B194;\n        background-color: rgba(130, 177, 148, 0.18);\n        transform: translateY(1px);\n    }\n}\n\n.selected {\n    background: #7A9E7E;\n    color: white;\n    font-weight: bold;\n}\n\n.disabled {\n    pointer-events: none;\n    color: #cccccc;\n    \n    &:hover {\n        background-color: transparent;\n        cursor: default;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationContainer": `Pagination_paginationContainer__VqRN1`,
	"paginationItem": `Pagination_paginationItem__6q3z4`,
	"dots": `Pagination_dots__6NsaB`,
	"disabled": `Pagination_disabled__owdrN`,
	"selected": `Pagination_selected__MZoCF`
};
export default ___CSS_LOADER_EXPORT___;
